import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import { SFPalette } from "./lib/color";

export const notoSansKr = {
  style: {
    fontFamily: "NotoSansKR",
  },
  className: "noto-sans-kr",
};

export const inter = {
  style: {
    fontFamily: "Inter",
  },
  className: "inter",
};

export const fontWeight = {
  Black: 900,
  ExtraBold: 800,
  Bold: 700,
  SemiBold: 600,
  Medium: 500,
  Regular: 400,
  Light: 300,
  ExtraLight: 200,
  Thin: 100,
};

const systemFont = [
  "--rubik-font",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];

// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#A19BFD",
      light: "#E8E7FF",
      dark: "#6D69FB",
      contrastText: "#fff",
    },
    secondary: {
      main: "#6862C5",
      light: "#A19BFD",
      dark: "#6D69FB",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: ["NotoSansKR", "Inter", ...systemFont].join(","),
    h1: {
      fontWeight: fontWeight.Bold,
      fontSize: "2.5rem",
      letterSpacing: "-0.02em",
      lineHeight: "3.25rem",
    },
    h2: {
      fontWeight: fontWeight.Bold,
      fontSize: "2.25rem",
      lineHeight: "2.875rem",
      letterSpacing: "-0.02em",
    },
    h3: {
      fontWeight: fontWeight.Medium,
      fontSize: "2rem",
      lineHeight: "2.675rem",
      letterSpacing: "-0.02em",
    },
    h4: {
      fontWeight: fontWeight.Medium,
      fontSize: "1.5rem",
      lineHeight: "2.125rem",
      letterSpacing: "-0.02em",
    },
    h5: {
      fontWeight: fontWeight.Regular,
      fontSize: "1.25rem",
      lineHeight: "1.875rem",
      letterSpacing: "-0.02em",
    },
    h6: {
      fontWeight: fontWeight.Regular,
      fontSize: "1.125rem",
      lineHeight: "1.5rem",
      letterSpacing: "-0.02em",
    },
    body1: {
      fontWeight: fontWeight.Regular,
      fontSize: "1rem",
      lineHeight: "1.5rem",
      letterSpacing: "-0.02em",
    },
    body2: {
      fontWeight: fontWeight.Regular,
      fontSize: "0.875rem",
      lineHeight: "1.375rem",
      letterSpacing: "-0.02em",
    },

    subtitle1: {
      fontWeight: fontWeight.Medium,
      fontSize: "1.25rem",
      letterSpacing: "-0.02em",
    },
    subtitle2: {
      fontWeight: fontWeight.Medium,
      fontSize: "1rem",
      letterSpacing: "-0.02em",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        // Checkbox border radius 50%
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-inputMultiline::placeholder": {
            fontSize: "1rem",
          },
          "& .MuiOutlinedInput-root": {
            "& .MuiInputBase-input": {},
            "& fieldset": { borderRadius: 8 },
            "&.Mui-focused fieldset": {
              borderWidth: 1,
            },
          },
          "& .MuiFilledInput-root": {
            borderRadius: 12,
          },
          "& .MuiInput-underline:before": {
            borderBottom: `1px solid ${SFPalette.lightGrey1}`,
          },
          // "& .MuiInput-underline:hover:before": {
          //   borderBottom: "2px solid blue",
          //   marginTop: "12px",
          // },
          // "& .MuiInput-underline:after": {
          //   borderBottom: "3px solid red",
          //   marginTop: "12px",
          // },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: SFPalette.shuffleColor, // 주요 색상
          borderRadius: "100px", // border radius
        },
        arrow: {
          color: SFPalette.shuffleColor, // 화살표의 색상
          "&:before": {
            borderRadius: "50%", // 화살표 둥글게
          },
        },
      },
    },
    MuiContainer: {
      // Set gutter 24px
      styleOverrides: {
        root: {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
          "&:disabled": {
            // color: "white",
          },
          boxShadow: "none",
          "&.MuiButton-sizeLarge": {
            borderRadius: 12,
            padding: "12px 16px",
            height: 56,
            fontSize: "1rem",
            fontWeight: fontWeight.Bold,
          },
          "&.MuiButton-sizeMedium": {
            borderRadius: 8,
            fontWeight: fontWeight.SemiBold,
          },
          "&.MuiButton-sizeSmall": {
            borderRadius: 4,
            fontWeight: fontWeight.SemiBold,
          },
        },
      },
    },
  },
});

export default theme;
